import { ConditionalOfferNotice } from 'components/ApplicationOverview/ConditionalOfferNotice/ConditionalOfferNotice';
import { DisabledEarlyRepaymentCalculator } from 'components/EarlyRepaymentCalculator/DisabledEarlyRepaymentCalculator';
import { EarlyRepaymentCalculator } from 'components/EarlyRepaymentCalculator/EarlyRepaymentCalculator';
import { Offer } from 'components/SummaryCard/SummaryCard.helpers';
import { useLocale } from 'hooks/useLocale';
import { RCFRepaymentInfo } from '../RCFRepaymentInfo/RCFRepaymentInfo';
import { ConfirmOffer } from './ConfirmOffer/ConfirmOffer';
import { RejectOffer } from './RejectOffer/RejectOffer';
import { useReviewOffer } from './ReviewOffer.context';

export const ReviewOffer = () => {
  const { isUK } = useLocale();

  const {
    hasMultipleOffers,
    isRCFView,
    selectedOfferId,
    selectedApplication,
    offerDecision,
    selectedOfferMonthlyRepayment,
  } = useReviewOffer();

  const formalOffers =
    selectedApplication?.formal_offer_sets?.[0]?.formal_offers || [];

  const selectedOffer = formalOffers.find(
    (offer) => offer.offer_id === selectedOfferId,
  );

  const { available_funds, max_amount } = formalOffers[0] || {};
  const availableFundsEqualOfferedAmount = available_funds === max_amount;
  const isTopUpOffer =
    available_funds && max_amount && !availableFundsEqualOfferedAmount;

  const currentOffer =
    selectedOffer || (!hasMultipleOffers ? formalOffers[0] : undefined);

  const showRCFInfo = isRCFView && offerDecision === Offer.UNDECIDED;

  const showCalculator =
    !showRCFInfo &&
    (selectedOffer || !hasMultipleOffers) &&
    selectedApplication &&
    !isTopUpOffer &&
    offerDecision === Offer.UNDECIDED;

  const showDisabledCalculator =
    !showRCFInfo &&
    hasMultipleOffers &&
    !isTopUpOffer &&
    !selectedOffer &&
    offerDecision === Offer.UNDECIDED;

  const showConditionalOfferNotice =
    selectedApplication?.status === 'conditional_offer' &&
    isUK &&
    offerDecision !== Offer.REJECT;

  return (
    <div data-testid="review-offer">
      {showConditionalOfferNotice && (
        <ConditionalOfferNotice
          vatMonthsRequired={selectedApplication?.vat_months_required}
          hasMultipleOffers={hasMultipleOffers}
        />
      )}
      {showRCFInfo && (
        <RCFRepaymentInfo
          offerId={currentOffer?.offer_id}
          maxAmount={currentOffer?.max_amount}
        />
      )}
      {showCalculator && (
        <EarlyRepaymentCalculator
          formalOffer={selectedOffer || formalOffers[0]}
          selectedOfferMonthlyPayments={selectedOfferMonthlyRepayment}
        />
      )}
      {showDisabledCalculator && <DisabledEarlyRepaymentCalculator />}
      {offerDecision === Offer.AGREE && selectedOffer && (
        <ConfirmOffer
          selectedOffer={selectedOffer}
          isRepeat={selectedApplication?.customer?.is_repeat && isUK}
        />
      )}
      {offerDecision === Offer.REJECT && <RejectOffer />}
    </div>
  );
};
